import type { FC } from 'react';
import { useCallback } from 'react';
import { Button } from '@chakra-ui/react';

export interface SwatchProps {
    onClick: (productId?: string) => void;
    onMouseEnter?: (productId?: string) => void;
    onMouseLeave?: (productId?: string) => void;
    color?: string;
    isActive?: boolean;
    productId?: string;
    value?: string;
    id: string;
    size?: 'small' | 'default';
}

// extension may be required if data type would be an image url instead of color name
export const Swatch: FC<SwatchProps> = ({
    id,
    color,
    isActive,
    onClick,
    productId,
    value,
    size = 'default',
    onMouseEnter,
    onMouseLeave,
}) => {
    const handleMouseEnter = useCallback(() => {
        onMouseEnter?.(productId);
    }, [onMouseEnter, productId]);

    const handleMouseLeave = useCallback(() => {
        onMouseLeave?.(productId);
    }, [onMouseLeave, productId]);

    return (
        <Button
            data-testid={id}
            onClick={() => onClick(productId)}
            isActive={isActive}
            padding={0}
            margin={0}
            minWidth="unset"
            _hover={{
                outline: '1.5px solid',
                outlineColor: 'slt-pepper.300',
                outlineOffset: '2.5px',
            }}
            _active={{
                outline: '1.5px solid',
                outlineColor: 'slt-pepper.1000',
                outlineOffset: '2.5px',
            }}
            _focusVisible={{
                outline: '1.5px solid',
                outlineColor: 'slt-pepper.1000',
                outlineOffset: '2.5px',
            }}
            background={color}
            borderRadius={24}
            borderWidth="1px"
            borderColor="slt-pepper.600"
            w={size === 'default' ? 9 : 6}
            h={size === 'default' ? 9 : 6}
            value={value}
            aria-label={`Color: ${value}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        />
    );
};

Swatch.defaultProps = {
    isActive: false,
    productId: undefined,
    value: undefined,
    color: undefined,
    size: 'default',
    onMouseEnter: undefined,
    onMouseLeave: undefined,
};
